import type { SubmissionSummary } from '../api/types'

/**
 * Uviva Direct OUT-operation delivery status, derived from the Odoo picking
 * state synced by the reconciler with delivered_at as the terminal signal.
 * Lives in its own module (not the drawer component) so react-refresh's
 * only-export-components rule stays satisfied.
 */
export function directDeliveryStatus(
  s: SubmissionSummary,
): { label: string; variant: 'success' | 'info' | 'neutral' } {
  if (s.delivered_at) return { label: 'Delivered', variant: 'success' }
  if (s.odoo_picking_state === 'done') return { label: 'Shipped', variant: 'info' }
  if (s.odoo_picking_state === 'assigned' || s.odoo_picking_state === 'confirmed') {
    return { label: 'Reserved — awaiting warehouse', variant: 'info' }
  }
  return { label: 'Pending', variant: 'neutral' }
}
